import React from "react"

import UI5MenuSeparator from "./separator"
import {MenuItem} from "../@const";

type Props = {
    className?      : string

    item            : MenuItem

    hasArrow?       : boolean
    isPopoverBtn?   : boolean
    disabled?       : boolean
    newFeature?     : boolean
    selectedId?     : any
    onClick?        : {(id:any):void}
}

export default function UI5MenuItem(props: Props) {

    if (props.item.type === 'separator') {
        return <UI5MenuSeparator />
    }

    const onClick = () => {
        if (!props.item.disabled && !props.disabled) {
            if (props.onClick) props.onClick(props.item.id);
            else if (props.item.onClick) props.item.onClick(props.item.id);
        }
    }

    const classes = Classes('item', props.className, props.item.className, {
        'selected'                  : !!props.selectedId && props.item.id === props.selectedId,
        'disabled'                  : props.item.disabled || props.disabled
    })

    const arrowClasses = Classes("right-arrow", "ui5-ico-12", "i5-angle-right", {
        "is-popover-btn": props.isPopoverBtn
    })

    return (
        <div className={classes} onClick={onClick}>
            <div className="row">
                {props.item.icon && <div className={Classes('icon', props.item.icon)}/>}
                <div className="name">
                    {props.item.label}
                    {props.newFeature}
                </div>
                {!_.isNil(props.item.counterIcon) && <div className={Classes("counter-icon", props.item.counterIcon)}/>}
                {!_.isNil(props.item.counter) && <div className="counter">{props.item.counter}</div>}
                {(props.hasArrow || props.isPopoverBtn) && <div className={arrowClasses}></div>}
            </div>
        </div>
    )
}
